"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHandler = void 0;
const router_1 = require("@keplr-wallet/router");
const messages_1 = require("./messages");
const getHandler = (service) => {
    return (env, msg) => {
        switch (msg.constructor) {
            case messages_1.PushInteractionDataMsg:
                return handlePushInteractionDataMsg(service)(env, msg);
            case messages_1.PushEventDataMsg:
                return handlePushEventDataMsg(service)(env, msg);
            default:
                throw new router_1.KeplrError("interaction", 110, "Unknown msg type");
        }
    };
};
exports.getHandler = getHandler;
const handlePushInteractionDataMsg = (service) => {
    return (_, msg) => {
        return service.pushData(msg.data);
    };
};
const handlePushEventDataMsg = (service) => {
    return (_, msg) => {
        return service.pushEvent(msg.data);
    };
};
//# sourceMappingURL=handler.js.map